(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["reviews-section"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  $('.review-slider').slick({
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev custom-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="11" height="21" viewBox="0 0 11 21" fill="none"><path d="M10.1516 2.29688L2.25313 10.5L10.1516 18.75C10.3391 18.9062 10.4328 19.0742 10.4328 19.2539C10.4328 19.4336 10.3391 19.6172 10.1516 19.8047C9.99532 20.0078 9.82735 20.1094 9.64766 20.1094C9.46797 20.1094 9.28438 20.0078 9.09688 19.8047L0.401566 11.0391C0.245316 10.8672 0.167191 10.6953 0.167191 10.5234C0.167191 10.3516 0.245316 10.1641 0.401566 9.96094L9.09688 1.19531C9.28438 0.992188 9.46797 0.890625 9.64766 0.890625C9.82735 0.890625 9.99532 0.992188 10.1516 1.19531C10.3391 1.36719 10.4328 1.54688 10.4328 1.73438C10.4328 1.92188 10.3391 2.10938 10.1516 2.29688Z" fill="#333333"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next custom-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="11" height="21" viewBox="0 0 11 21" fill="none" style="transform:rotate(180deg);"><path d="M10.1516 2.29688L2.25313 10.5L10.1516 18.75C10.3391 18.9062 10.4328 19.0742 10.4328 19.2539C10.4328 19.4336 10.3391 19.6172 10.1516 19.8047C9.99532 20.0078 9.82735 20.1094 9.64766 20.1094C9.46797 20.1094 9.28438 20.0078 9.09688 19.8047L0.401566 11.0391C0.245316 10.8672 0.167191 10.6953 0.167191 10.5234C0.167191 10.3516 0.245316 10.1641 0.401566 9.96094L9.09688 1.19531C9.28438 0.992188 9.46797 0.890625 9.64766 0.890625C9.82735 0.890625 9.99532 0.992188 10.1516 1.19531C10.3391 1.36719 10.4328 1.54688 10.4328 1.73438C10.4328 1.92188 10.3391 2.10938 10.1516 2.29688Z" fill="#333333"/></svg></button>',
    responsive: [
    {
        breakpoint: 1260,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
});

  } catch(e) { console.error(e); }
})();
})();
